/**
 * MODULE: domain/pages/frontend/hooks/useCallTranscriptPreview.ts
 * PURPOSE: TanStack Query hook for live call transcript preview blocks
 */

import { useQuery } from '@tanstack/react-query';
import { pagesCallPreviewApi } from '../api/pagesCallPreviewApi';

export const CALL_TRANSCRIPT_PREVIEW_KEY = (callId: string) =>
  ['pages', 'call-transcript-preview', callId] as const;

export function useCallTranscriptPreview(
  callId: string | null | undefined,
  options?: { enabled?: boolean }
) {
  const id = callId?.trim() ?? '';
  const enabled = options?.enabled !== false;

  return useQuery({
    queryKey: CALL_TRANSCRIPT_PREVIEW_KEY(id),
    queryFn: () => pagesCallPreviewApi.getCallTranscriptPreview(id),
    enabled: Boolean(id) && enabled,
    staleTime: 60_000,
  });
}
